import { createContext, createEffect, createSignal, onMount, useContext } from 'solid-js';
import type { Signal, ParentProps } from 'solid-js';

const ctx = createContext<Signal<boolean>>();

export function ActivationProvider(props: ParentProps) {
	const [active, setActive] = createSignal(false);
	const [ref, setRef] = createSignal<HTMLElement>();

	onMount(() => {
		window.parent?.postMessage({ ready: true }, '*');
		function activate() {
			setActive(true);
			window.parent?.postMessage({ activate: true }, '*');
		}
		ref()?.addEventListener('click', activate);
		ref()?.addEventListener('touchend', activate);
	});

	createEffect(() => {
		if (!active()) {
			window.parent?.postMessage({ deactivate: true }, '*');
		}
	});

	return (
		<ctx.Provider value={[active, setActive]}>
			<div ref={setRef}>{props.children}</div>
		</ctx.Provider>
	);
}

export function useActivation() {
	return useContext(ctx)!;
}
